<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header">
      <div class="flex" style="justify-content: space-between;">
        <div>
          <img src="@/assets/home/new.png" alt="" />
          <span class="hardtext">构件统计</span>
        </div>
        <el-button
          type="primary"
          @click="Intercomponentstatistics()"
          >保存</el-button
        >
      </div>
    </div>
    <!-- card body -->
    <div>
      <el-table
        :header-cell-style="{
          background: '#EBEFF2',
          color: '#1E2134',
          fontWeight: 'bold',
        }"
        align="center"
        stripe
        :data="list"
      >
        <el-table-column align="center" label="名称" prop="bdst03">
          <!-- <template slot-scope="scope">
            <el-input
              v-model="scope.row.bdst03"
              size="normal"
              clearable
            ></el-input>
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="数值">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bdst04"
              size="normal"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="单位">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bdst05"
              size="normal"
              clearable
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { Getcomponentstatistics, Intercomponentstatistics } from "@/setAxios";
import dayjs from "dayjs";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      list: [
        { bdst03: "生产总需量:", bdst04: "", bdst05: "" },
        { bdst03: "当前产量：", bdst04: "", bdst05: "" },
        { bdst03: "当日产量：", bdst04: "", bdst05: "" },
        { bdst03: "当前库存量：", bdst04: "", bdst05: "" },
        { bdst03: "当日入库：", bdst04: "", bdst05: "" },
        { bdst03: "已发货：", bdst04: "", bdst05: "" },
        { bdst03: "当日发货:", bdst04: "", bdst05: "" },
      ],
    };
  },

  mounted() {},
  created() {
    this.Getcomponentstatistics();
  },
  methods: {
    Getcomponentstatistics() {
      let params = { xid: this.$store.state.xid };
      Getcomponentstatistics({ params }).then((res) => {
        if (res.Data.length > 0) this.list = res.Data;
      });
    },
    Intercomponentstatistics() {
      let that = this;
      this.list.map(function(i) {
        i.bdst02 = that.$store.state.xid;
        i.bdst06 = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
        return i;
      });
      let params = {
        xid: this.$store.state.xid,
        cmp: this.list,
      };
      Intercomponentstatistics(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
          this.Getcomponentstatistics();
        } else {
          this.$message({
            type: "error",
            message: "操作有误!",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
